
import commonGoodsThirdClass from './commonGoodsThirdClass.vue';

// import { Vue, Component } from "vue-property-decorator";
// import dayjs from "dayjs";
// import { Header } from "element-ui";

export default {
	
  data(){
	  return{
		dialogVisible: false,
		dialogTitle:'',
		productAttrCate:{
		  name:'',
		  id:null,
		  ptCode:null
		},  
		rules: {
		  name: [
		    { required: true, message: '请输入类型名称', trigger: 'blur' }
		  ]
		},
		settleType:1,
		tableData:[],
		pageNo:1,
		pageSize:10,
		form:{},

		dialogImageUrl: '',
		fileList: [],
		objClass: {
			upLoadShow: true,
			upLoadHide: false,
		},
        upLoadFile:{}
	  }
  },
  // private get pagedTableData() {
  //   return this.tableData.filter(
  //     (v, i) =>
  //       i >= (this.pageNo - 1) * this.pageSize &&
  //       i <= this.pageNo * this.pageSize - 1
  //   );
  // }

  mounted() {

	let paramter = {
		pageNum:1,
		pageSize:1000000,
		ptLevel:2,
		parentCode:this.$route.query.parentCode,
	};
	this.$http.get("productType/list", {params:paramter}).then((res: any) =>{
		
		this.tableData = res.data.data.data;
		this.tableData = this.tableData.map(item=>{

			if(item.enable == 1) {

				item.enable = true;
			} else {

				item.enable = false;
			}
			return item;
		});
		
	});
  },
  
  methods:{
	
	handleChange(file:any, fileList:any) {
		this.objClass.upLoadHide = true;//上传图片后置upLoadHide为真，隐藏上传框
		this.objClass.upLoadShow = false;

		this.uploadFile = file.raw;
	},
	handleRemove(file:any, fileList:any) {
		this.objClass.upLoadShow = true;//删除图片后显示上传框
		this.objClass.upLoadHide = false;
	},
	// 点击预览图的放大按钮后会触发handlePictureCardPreview
	handlePictureCardPreview(file:any) {
		this.dialogImageUrl = file.url;
	},
	addImage(index:any,row:any){
		// 点击查看大图
		console.log(row);
	},
	handleSizeChange(val: number) {
	  console.log(`每页 ${val} 条`);
	  this.pageSize = val;
	  this.pageNo = 1;
	},
	
	handleCurrentChange(val: number) {
	  console.log(`当前页: ${val}`);
	  this.pageNo = val;
	},
	getAttrList(index:any, row:any) {

	  this.$router.push({path: '/MyStore/commonGoodsThirdClass',query:{cid:row.ptId,cname:row.ptName,parentCode:row.ptCode}})
  	},
	onSubmit() {
	  console.log(this.form);
	},
	addSubmit() {
		  
		// 新增品类
		this.settleType = 1;
		this.dialogVisible = true;
		this.dialogTitle = "编辑类型";
		// 显示上传图片框
		this.objClass.upLoadHide = false;//上传图片后置upLoadHide为真，隐藏上传框
        this.objClass.upLoadShow = true;
		this.productAttrCate.name = '';
		
	},
	handleClose() {
		
		this.dialogVisible = false;
		this.fileList = [];
		this.productAttrCate.name = '';
	},
	handleUpdate(index:any, row:any){
		  
		  this.settleType = 2;
		  this.dialogVisible = true;
		  this.dialogTitle = "编辑类型";
		  this.productAttrCate.name = row.ptName;
		  this.productAttrCate.id = row.ptId;
		  this.productAttrCate.ptCode = row.ptCode;
		  this.fileList.push({
                name: 'img.jpg',
                url: row.ptImage,
                uid: row.ptId
          });

          // 隐藏上传图片框
          this.objClass.upLoadHide = true;//上传图片后置upLoadHide为真，隐藏上传框
          this.objClass.upLoadShow = false;
	},
	handleDelete(index:any,row:any) {
		
		let ptCodeList = [];
		ptCodeList.push(row.ptCode);

		this.$http.post("productType/delete",ptCodeList).then((res: any) =>{
		
			this.fileList = [];
			this.$confirm('删除成功');
			this.dialogVisible = false;
			window.location.reload();
		});
	},
	cancelUpload(){

		// 取消上传
		this.dialogVisible = false;
		this.fileList = [];
		this.productAttrCate.name = '';
	},
	sureSubmit(value:any){
		  
		  this.fileList = [];
		  let settleType = value;
		  var formData = new FormData();
		  formData.append('file',this.uploadFile);

		  if(settleType == 1) {
			  
			  // 新增类型

			  formData.append('ptLevel','2');
			  formData.append('ptName',this.productAttrCate.name);
			  formData.append('parentCode',this.$route.query.parentCode);

			  this.$http.post("productType", formData).then((res: any) =>{
			  	
			  		this.$confirm('添加成功');
			  		this.dialogVisible = false;

					window.location.reload();
			  });
			  
		  } else {
			  
			  // 编辑类型
			  formData.append('ptLevel','2');
			  formData.append('ptName',this.productAttrCate.name);
			  formData.append('ptCode',this.productAttrCate.ptCode);
			  this.$http.put("productType", formData).then((res: any) =>{
			  	
					this.dialogVisible = false;
			  		this.$confirm('修改成功');
					window.location.reload();
			  });
		  }
	},
	userStateChange(item:any){
		  
		  console.log('我是item',item);
		  // 是否开启类型
		  // 编辑类型
		  var itemTemp = item;
		  this.$http.put("productType/enable?ptCode="+itemTemp.ptCode).then((res: any) =>{
                    
				let data = res.data;
				if(data.code == 200) {
					
					this.$confirm(data.msg);
				}
					
			});
	}  
	  
  }
}
